
import $ from 'jquery';
import { Component, Vue } from 'vue-property-decorator';
import { SurveyResultMeta } from '../../backend/backendapi';

@Component
export default class StillValidConfirmModal extends Vue {
  meta: SurveyResultMeta | null = null;

  public open(meta: SurveyResultMeta): void {
    this.meta = meta;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }
}
